import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { ICourseDetailsStateParams } from '../../../routes/ap_course_details_routes';

export class MultiCourseDetailController {
  private __openDrawer: boolean;
  private termId: number = INVALID_ID;
  private showCourseDetailsMenu: boolean = false;
  private allowRemoveCourseOption: boolean = false;
  private isPast = false;
  constructor(
    private $state: ng.ui.IStateService,
    private ngAPCourseInfoQuery: any,
    private $stateParams: ng.ui.IStateParamsService,
    private loadMmCourseInfoCommand: ICommand,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any
  ) {}
  $onInit() {
    this.__openDrawer = true;
    const stateParams: ICourseDetailsStateParams = _4.get(this.$stateParams, 'courseDetailsParams', {
      courseNk: `${INVALID_ID}`,
      courseId: INVALID_ID,
      termId: INVALID_ID,
      slotId: INVALID_ID,
      isPast: false,
      plannedCourseId: INVALID_ID,
      showCourseDetailsMenu: false
    });
    this.loadMmCourseInfoCommand(stateParams.courseNk);
    this.termId = stateParams.termId;
    this.allowRemoveCourseOption = this.termId > 0 && stateParams.status === 'PLANNED';
    this.isPast = _4.get(stateParams, 'isPast', false);
    this.showCourseDetailsMenu = stateParams.showCourseDetailsMenu;
  }
  closeDetails() {
    this.__openDrawer = false;
    this.$state.go('^');
  }
}
class MultiAPCourseDetails implements ng.IComponentOptions {
  public bindings: Record<string, string>;
  public controller: any;
  public templateUrl: any;
  public transclude: boolean;
  constructor() {
    this.controller = MultiCourseDetailController;
    this.templateUrl = 'capability-ng-academic-planner/src/global/components/course_detail/mm_course_details.html';
    this.bindings = {};
    this.transclude = true;
  }
}

angular.module('capability-ng-academic-planner').component('multiApCourseDetails', new MultiAPCourseDetails());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/mm_course_details.ts